import { Crown, LayoutDashboard, Shield, Sparkles, User } from "lucide-react"

import type { LocalizedText } from "@/shared/i18n"

import type { LucideIcon } from "lucide-react"

interface NavItem {
  label: LocalizedText
  icon: LucideIcon
  path: string
  requiresChatId: boolean
  isPro?: boolean
}

export const navItems: readonly NavItem[] = [
  {
    label: { key: "dashboard", fallback: "Dashboard" },
    icon: LayoutDashboard,
    path: "/dashboard",
    requiresChatId: false
  },
  {
    label: { key: "Moderation", fallback: "Moderation" },
    icon: Shield,
    path: "/moderation",
    requiresChatId: true
  },
  {
    label: { key: "ai-features", fallback: "AI Settings" },
    icon: Sparkles,
    path: "/group-settings",
    requiresChatId: true
  },
  {
    label: { key: "celestia-pro-nav", fallback: "Celestia Pro" },
    icon: Crown,
    path: "/celestia-pro",
    isPro: true,
    requiresChatId: false
  },
  {
    label: { key: "personal", fallback: "Personal" },
    icon: User,
    path: "/user-profile",
    requiresChatId: false
  }
]
